import { createBrowserRouter } from 'react-router-dom';

// project imports
import MainRoutes from './MainRoutes';
import LoginRoutes from './LoginRoutes';
import NotFoundPage from 'pages/notFoundPage/NotFoundPage';
// ==============================|| ROUTING RENDER ||============================== //

const router = createBrowserRouter(
  [
    MainRoutes, 
    LoginRoutes,
    {
      path: '*', 
      element: <NotFoundPage/>
    }
  ], 
  { basename: import.meta.env.VITE_APP_BASE_NAME });

export default router;
